import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { TuiSvgModule } from '@taiga-ui/core';
import { selectUserId } from '@us/web/auth/data-access';
import { OrdersApiService } from '@us/web/orders/data-access';
import { Order } from '@us/web/shared/data-access';
import { MessageService } from '@us/web/shared/feature';
import { BehaviorSubject, switchMap } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
    selector: 'us-order-rating',
    standalone: true,
    imports: [NgIf, TuiSvgModule, FormsModule, TranslocoModule, IonicModule],
    templateUrl: './order-rating.page.html',
    styleUrls: ['./order-rating.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderRatingPage implements OnInit {
    private readonly orderId: string;
    order: Order | null = null;
    rate = 0;
    description = '';

    isLoading = false;
    isSubmitted = false;

    private reload$ = new BehaviorSubject(0);

    constructor(
        private route: ActivatedRoute,
        private store: Store,
        private changeDetectorRef: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private messageService: MessageService,
        private router: Router,
        private ordersService: OrdersApiService
    ) {
        this.orderId = this.route.snapshot.params['id'];
    }

    ngOnInit(): void {
        this.getData();

        // this.messagingService.notifications$.pipe(filter(e => e)).subscribe(value => {
        //     const { entity_type, entity_id } = value;
        //
        //     if (entity_type === EntityType.Order && entity_id === this.orderId) {
        //         this.reload$.next(0);
        //     }
        // });
    }

    getData() {
        this.reload$
            .pipe(
                untilDestroyed(this),
                switchMap(() => this.ordersService.getOrder({ id: this.orderId }))
            )
            .subscribe({
                next: order => {
                    this.order = order;
                    const rating = order.rating;
                    if (rating) {
                        this.rate = rating.rating;
                        this.description = rating.description;
                        this.isSubmitted = true;
                    }

                    this.changeDetectorRef.detectChanges();
                },
                error: async err => {
                    console.log(err);
                    await this.router.navigate(['/orders']);
                }
            });
    }

    onSubmit() {
        this.isLoading = true;
        this.isSubmitted = false;
        this.changeDetectorRef.detectChanges();

        this.store
            .select(selectUserId)
            .pipe(first())
            .subscribe(accountId => {
                this.ordersService
                    .postRating({
                        rating: this.rate,
                        description: this.description,
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        order_id: this.orderId!,
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        account_id: accountId!
                    })
                    .subscribe({
                        next: response => {
                            this.isLoading = false;
                            this.isSubmitted = true;
                            this.changeDetectorRef.detectChanges();
                            this.messageService.success(this.translocoService.translate('message.success'));
                            this.router.navigate(['/']);
                        },
                        error: error => {
                            this.isLoading = false;
                            this.changeDetectorRef.detectChanges();
                        }
                    });
            });
    }
}
